import { Box, CircularProgress, circularProgressClasses, type CircularProgressProps } from '@mui/material';
import './styles.scss';

interface StatsCircularBarProps {
  percentage: number;
  descTitle: string;
  descValue: string;
}

function CustomCircularProgress(props: CircularProgressProps) {
  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: theme => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        disableShrink
        sx={{
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </Box>
  );
}

const StatsCircularBar = ({ percentage, descTitle, descValue }: StatsCircularBarProps) => {
  return (
    <div className="stats-circular-bar">
      <Box>
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CustomCircularProgress variant="determinate" thickness={3} value={percentage} size={150} />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div className="stats-circular-bar__text">
              <span className="stats-circular-bar__text__title">Total</span>
              <span className="stats-circular-bar__text__percentage">{percentage}%</span>
            </div>
          </Box>
        </Box>
      </Box>
      <Box className="stats-circular-bar__desc">
        <p className="stats-circular-bar__desc__title">{descTitle}</p>
        <p>{descValue}</p>
      </Box>
    </div>
  );
};

export default StatsCircularBar;
